import * as React from "react";
import { Icon } from "@grandvisionhq/icons";
import { AdyenBrands } from "../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
const getBrandIcon = (brand) => {
  switch (brand) {
    case AdyenBrands.MASTERCARD:
      return /* @__PURE__ */ React.createElement(Icon, { key: "mastercard", name: "mastercard", viewBox: "6 0 36 28", width: 36, height: 28 });
    case AdyenBrands.AMEX:
      return /* @__PURE__ */ React.createElement(Icon, { key: "amex", name: "amex", viewBox: "0 0 40 24", width: 40, height: 24 });
    case AdyenBrands.MAESTRO:
      return /* @__PURE__ */ React.createElement(Icon, { key: "maestro", name: "maestro", viewBox: "6 0 36 28", width: 36, height: 28 });
    case AdyenBrands.DANKORT:
      return /* @__PURE__ */ React.createElement(Icon, { key: "dankort", name: "dankort", viewBox: "0 0 39 19", width: 39, height: 19 });
    case AdyenBrands.VISA:
      return /* @__PURE__ */ React.createElement(Icon, { key: "visa", name: "visa", viewBox: "0 2 37 20", width: 37, height: 20 });
    case AdyenBrands.BANCONTACTMC:
      return /* @__PURE__ */ React.createElement(Icon, { key: "bancontact", name: "bancontact", width: 54, height: 33, viewBox: "1 0 54 33" });
    default:
      return void 0;
  }
};
const getCreditCardBrandsIcons = (brands) => {
  const uniqueBrands = Array.from(new Set(brands));
  return uniqueBrands.reduce((acc, brand) => [...acc, getBrandIcon(brand)], []);
};
export {
  getBrandIcon,
  getCreditCardBrandsIcons
};
//# sourceMappingURL=get-creditcard-brands-icons.js.map
